export default "__VITE_ASSET__CeA5nVtX__"